import Select from './select'
import Text from './text'
import setType from './setType'

export default function createAddressField(field, path) {
  field = setType(field)
  const fn = { select: Select, text: Text }
  const { identifier } = field
  let dependsOn = null
  if (field.dependent) {
    dependsOn = `${path}.${field.dependent}`
  }
  let input = fn[field.type]({ ...field, identifier, client: true })
  if (dependsOn) {
    input.dependsOn = dependsOn
  }
  return input
}



// WEBPACK FOOTER //
// ./src/modules/app/helpers/createAddressField.js